import React from 'react';

const backButtonClassName =
  'flex-shrink-0 p-1.5 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300';

/**
 * Shared site chrome: back control, AFS logo, page title, “Powered by” line, optional right-side actions.
 */
export default function AppPageHeader({ onBack, title, rightSlot = null, backAriaLabel = 'Back to home' }) {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-row items-center gap-3 sm:gap-4 lg:gap-6 py-4 sm:py-6">
          <button
            type="button"
            onClick={onBack}
            className={backButtonClassName}
            aria-label={backAriaLabel}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <img
            src="https://acsfutureschool.com/afs.png"
            alt="Logo"
            className="h-10 w-10 sm:h-12 sm:w-12 object-contain flex-shrink-0"
          />
          <div className="min-w-0 flex-1">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 break-words">{title}</h1>
            <span className="text-sm sm:text-base text-gray-600 block mt-1">
              Powered by{' '}
              <a
                href="https://abusayem.me"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                Md. Abu Sayem
              </a>
            </span>
          </div>
          {rightSlot != null && rightSlot !== false ? rightSlot : null}
        </div>
      </div>
    </header>
  );
}
